'use strict';

export default class Search {
  constructor() {

    let $searchBtn  = $('.search'),
        $header     = $('header.main'),
        $siteHeader = $('.site-header', $header),
        $searchCont = $('.search__cont'),
        $inputBlock = $('.search__input', $searchCont),
        $dummy      = $('<span class = "dummy"></span>'), // We use dummy to discover the width of the text.
        $label      = $('label', $searchCont),
        $input      = $('#searchField'),
        $icnDown    = $('.icon-sort-down', $searchCont),
        $mask       = $('<div class = "search-mask"/>'),
        $closeBar   = $('.search__close');

    this.suggestions = ['Birds', 'Bishan Park', 'City & Heritage Parks', 'Costal Parks', 'Community In Bloom', 'Community Parks', 'Concerts & Performances', 'Dining', 'DIY']

    // Append a mask to mask out contents on page when search is activated
    $('body').append($mask);
    $inputBlock.prepend($dummy);

    $searchBtn.on('click', function(e){
        e.preventDefault();

        if(!$siteHeader.hasClass('search-up')) {
            $siteHeader.addClass('search-up');
            $mask.fadeIn();
            $searchCont.fadeIn();
            $closeBar.fadeIn();
        } else {
            $siteHeader.removeClass('search-up');
            $searchCont.fadeOut();
            $mask.fadeOut();
            $closeBar.fadeOut();
        }
    });

    $closeBar.on('click', 'a', function(e){
        e.preventDefault();

        $siteHeader.removeClass('search-up');
        $searchCont.fadeOut();
        $mask.fadeOut();
        $closeBar.fadeOut();
    });

    $icnDown.on('click', function(){
        $input.typeahead('open');
        $input.typeahead('val', '');
        $input.focus();
    });

    $input.on('focus', function(){
        $label.fadeOut();
    });

    $input.on('blur', function(){
        if($input.val().length === 0)
            $label.fadeIn();
    });

    $input.on('keyup', function() {
        $dummy.text($input.val());
        $input.width($dummy.width() + 10);
    });

    let substringMatcher = (strs) => {
        return function findMatches(q, cb) {
            var matches,
                substrRegex;

            // an array that will be populated with substring matches
            matches = [];

            // regex used to determine if a string contains the substring `q`
            substrRegex = new RegExp(q, 'i');

            // iterate through the pool of strings and for any string that
            // contains the substring `q`, add it to the `matches` array
            $.each(strs, function(i, str) {
                if (substrRegex.test(str)) {
                    matches.push(str);
                }
            });

            cb(matches);
        };
    };


    if(typeof window.suggestions !== 'undefined') {
        this.suggestions = window.suggestions
    }

    $input.typeahead({
      hint: true,
      highlight: true,
      minLength: 0
    },
    {
      name: 'states',
      source: substringMatcher(this.suggestions),
      limit: 10
    });

    $input.bind('typeahead:select', function(ev, suggestion) {
       $input.trigger('keyup');
    });
  }
}
